import { createFileRoute } from "@tanstack/react-router";
import { useSimpleForm } from "@/hooks/use-simple-form";
import { useTranslate } from "@/hooks/use-translate";
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  StockBatchForm,
  type StockBatchPayment,
} from "@/components/stock-batch/stock-batch-form";
import useAppStore from "@/store";
import type { Product } from "@/store/Product";
import { generateBatchCode } from "@/lib/utils";
import { addDays } from "date-fns";

export const Route = createFileRoute(
  "/(dasboard)/inventory/stock-batchs/create",
)({
  component: CreateStockBatchPage,
});

function CreateStockBatchPage() {
  const store = useAppStore();
  const { t, formatDate } = useTranslate();

  const form = useSimpleForm({
    id: "",
    quantity: "",
    supplier_id: "",
    warehouse_id: "",
    product_id: "",
    unit_price: 0,
    batch_code: "",
    expiry_date: "",
    manufacturing_date: "",
    description: "",
    payments: [],
  });

  const [product, setProduct] = useState<Product | undefined>(undefined);

  useEffect(() => {
    if (store.auth.session) {
      form.setValue("shop_id", store.auth.session?.currentShop?.id);
      store.warehouse.fetch();
      store.supplier.fetch();

      store.shop
        .getStats(
          "2025-01-01",
          formatDate(addDays(new Date(), 2), "yyyy-mm-dd"),
        )
        .then((stats) => {
          console.log(stats);
          form.setValue(
            "batch_code",
            generateBatchCode(stats.stock_batches_count),
          );
        });
    }
  }, [store.auth.session]);

  const submit = async () => {
    store.errors.reset();

    store.stockBatch
      .create({
        ...form.values,
        shop_id: store.auth?.session?.shop?.id,
        user_id: store.auth.session?.user.id,
        payments: form.values.payments.map((item: StockBatchPayment) => item),
      })
      .then(() => {
        store.stockBatch.fetch();
        form.reset();
        setProduct(undefined);
        window.history.back();
      })
      .catch(store.errors.catch);
  };

  return (
    <section>
      {/* {store.testing.canTest && (
        <CreateStockBatchTest setProduct={setProduct} form={form} />
      )} */}

      <div className="mt-4 flex justify-between mb-4">
        <h2 className="text-xl font-semibold">
          {t("Create a new stock batch")}
        </h2>
        <div>
          <Button
            onClick={submit}
            loading={store.stockBatch.loading("create")}
            className="py-2"
          >
            {t("Create")}
          </Button>
        </div>
      </div>

      <div>{store.errors.render()}</div>

      <StockBatchForm
        mode="create"
        form={form}
        setProduct={setProduct}
        product={product}
      />

      <Button
        className="mt-8 px-6 py-3"
        onClick={submit}
        loading={store.stockBatch.loading("create")}
      >
        {t("Create")}
      </Button>
    </section>
  );
}
